import { render } from "./AlbumsMassive.vue?vue&type=template&id=8c1922d2&scoped=true"
import script from "./AlbumsMassive.vue?vue&type=script&lang=js"
export * from "./AlbumsMassive.vue?vue&type=script&lang=js"

import "./AlbumsMassive.vue?vue&type=style&index=0&id=8c1922d2&scoped=true&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1922d2"]])

export default __exports__